import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

export const RAG = { red: "bg-red-100 text-red-800 border-red-300", amber: "bg-amber-100 text-amber-800 border-amber-300", green: "bg-emerald-100 text-emerald-800 border-emerald-300" };
export const RagPill = ({ rag }) => <span className={`inline-block px-2 py-0.5 rounded-full border text-[10px] uppercase tracking-wider ${RAG[rag] || RAG.green}`}>{rag}</span>;

/** Read-only derived summary shown on the mandate page. No alerts, no notifications. */
export default function StabilisationHealth({ mandateId }) {
    const [h, setH] = useState(null);
    useEffect(() => { api.get(`/distressed/stabilisation/mandates/${mandateId}/health`).then((r) => setH(r.data)).catch(() => setH(null)); }, [mandateId]);
    if (!h) return null;
    const reasons = Object.entries(h.workstreams).flatMap(([ws, v]) => v.reasons.map((r) => `${ws}: ${r}`));
    return (
        <Card data-testid="stabilisation-health">
            <CardHeader className="pb-2 flex-row items-center justify-between">
                <CardTitle className="text-sm flex items-center gap-2">Stabilisation <RagPill rag={h.overall_rag} /></CardTitle>
                <Link to={`/distressed/stabilisation?mandate=${mandateId}`} data-testid="open-stabilisation"><Button variant="outline" size="sm">{h.read_only ? "View tracker" : "Open tracker"}</Button></Link>
            </CardHeader>
            <CardContent className="text-sm space-y-2">
                <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-muted-foreground">
                    <span>Overdue <b className="text-foreground font-mono">{h.overdue_count}</b></span>
                    <span>Due in 7 days <b className="text-foreground font-mono">{h.upcoming_count["7"]}</b></span>
                    <span>Due in 14 days <b className="text-foreground font-mono">{h.upcoming_count["14"]}</b></span>
                    <span>Creditor pressure <b className="text-foreground font-mono">{h.open_creditor_pressure_count}</b> (£{Math.round(h.open_creditor_pressure_total).toLocaleString("en-GB")})</span>
                    {h.cash_variance?.runway_weeks != null && <span>Runway <b className="text-foreground font-mono">{h.cash_variance.runway_weeks} wks</b></span>}
                </div>
                {h.cash_variance?.reforecast_flag && <div className="text-xs text-red-700" data-testid="reforecast-flag">{h.cash_variance.reforecast_reason}</div>}
                {reasons.slice(0, 4).map((r) => <div key={r} className="text-xs text-muted-foreground">• {r}</div>)}
                {h.read_only && <div className="text-xs text-muted-foreground">This mandate is closed; the tracker is read-only.</div>}
            </CardContent>
        </Card>
    );
}
